import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import "../../styles/dashboard-features/dashboard-features.css";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import FeatureGroupingList from "../../components/feature-control/feature-grouping/FeatureGroupingList";
import { fetchDashboardFeatureGroupingdata } from "../../redux/dashboard-features/featuresSlice";
import { selectUser } from "../../components/auth/auth.selector";
import FeatureGroupingForm from "../../components/feature-control/feature-grouping/FeatureGroupingForm";
import GroupedFeaturesListings from "./GroupedFeaturesListings";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";

const DashFeatureGrouping = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    isActive: "",
    selectedAccountType: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    default_for: allFilters.selectedAccountType?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getDashboardFeatureGrouping(filters) {
    dispatch(
      fetchDashboardFeatureGroupingdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getDashboardFeatureGrouping(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      default_for: allFilters.selectedAccountType?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.selectedAccountType, allFilters.isActive]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Dashboard Feature Grouping">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <FeatureGroupingForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getDashboardFeatureGrouping(filters)}
            />
          ) : modValues.cardName === "mapped_features" ? (
            <div className={`createNewCTOModalContainer midWidthModal`}>
              <ModalHeadAndClose
                title={`${modValues.cardName?.replace(/_/g, " ")}`}
                onClose={onCloseModal}
              />

              <GroupedFeaturesListings rowData={modValues.rowData} />
            </div>
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Dashboard Feature Grouping"}
              createBtnTxt={"+ Add New Feature Group"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getDashboardFeatureGrouping(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <SearchNButtons
              pageName={"dash-feature-grouping"}
              filters={allFilters}
              setFilters={setAllFilters}
              searchFilterApplied={searchFilterApplied}
              onClickSearch={onClickSearch}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <FeatureGroupingList
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getDashboardFeatureGrouping(filters)}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default DashFeatureGrouping;